export const stringSort = (a, b) => {
	const nameA = a?.toUpperCase();
	const nameB = b?.toUpperCase();
	if (nameA < nameB) {
		return -1;
	}
	if (nameA > nameB) {
		return 1;
	}
	return 0;
};

export const countrySort = (a, b) => {
	return stringSort(a.text, b.text);
};

export function stringDateSort(a: string, b: string) {
	return (new Date(b).getTime() - new Date(a).getTime());
}

export function GetUniqueObjectsByProperty<T>(objects: T[], propName: string): T[] {
	if (!objects) {
		return null;
	}

    const seen = new Map();
    return objects.filter((item) => {
        const key = item[propName];
        const keep = !seen.has(key);
        if (keep) seen.set(key, true);
        return keep;
    });
}

export function sortObj<T>(list: T[], key: string, descending: boolean) {
	function compare(a, b) {
		const item1 = a[key] === null ? '' : a[key];
		const item2 = b[key] === null ? '' : b[key];
		const type = (typeof (item1) === 'string' ||
			typeof (item2) === 'string') ? 'string' : 'number';
		let result;
		if (type === 'string') result = descending ? item1?.localeCompare(item2) : item2?.localeCompare(item1);
		else result = descending ? item1 - item2 : item2 - item1;
		return result;
	}
	return list.sort(compare);
}
